import React, { useState } from 'react';
import { useQueryClient } from 'react-query';
import { useSelector } from 'react-redux';
import { useEffectOnce } from 'react-use';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';
import {
  adviserFirstNameSelector as selectAdvisorFirstName,
  showClientsList as selectShowClientList,
} from '../AdviserArea/AdviserAreaSelector';
import { Box } from '../CommonComponents/OPL/Box/Box';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { queryKeys } from './api/queryKeys';
import { fetchClientList } from './api/useClientListQuery';
import { Wrapper } from './ClientSearch.styles';
import { ClientCombobox } from './components/ClientCombobox/ClientCombobox';
import { ClientList } from './components/ClientList/ClientList';
import { Navigation } from './components/Navigation/Navigation';

export const ClientSearch = () => {
  const [isClientListOpen, setIsClientListOpen] = useState(false);

  const queryClient = useQueryClient();

  const adviserFirstName = useSelector(selectAdvisorFirstName);
  const showClientList = useSelector(selectShowClientList);

  useDocumentTitle();

  useEffectOnce(() => {
    queryClient.prefetchInfiniteQuery(queryKeys.clientList(), () => fetchClientList());

    return () => {
      queryClient.removeQueries(queryKeys.clientListAll());
    };
  });

  return (
    <>
      <Wrapper as="main">
        <Text as="h1" fontSize="h2" fontWeight={500} color="neutral.900" mb="12">
          Welcome {adviserFirstName}
        </Text>

        <Box width="100%" maxWidth={600} mx="auto" mb="24">
          <ClientCombobox size="large" />
        </Box>

        <Navigation onClientListClick={() => setIsClientListOpen(true)} />
      </Wrapper>

      {showClientList && isClientListOpen && (
        <ClientList onClose={() => setIsClientListOpen(false)} />
      )}
    </>
  );
};
